// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2GWQc","title":"Images45_title__OQKu9","images":"Images45_images__vxOAk"};